/**
 * Application route paths
 */
export const ROUTES = {
  HOME: '/',

  AUTH: {
    LOGIN: '/login',
    SIGNUP: '/sign-up',
    FORGOT_PASSWORD: '/forgot-password',
    CHECK_EMAIL: '/check-email',
    RESET_PASSWORD: '/reset-password',
  },

  DASHBOARD: {
    HOME: '/dashboard',
    OFFERS: '/my-offers',
    ENQUIRY_MANAGEMENT: '/my-enquiries',
    ENQUIRED_PROPERTIES: '/enquired-properties',
    MY_PROPERTIES: '/my-properties',
    PROPERTY: (id: string) => `/properties/${id}`,
    MY_PROPERTY: (id: string) => `/my-properties/${id}`,
    PROFILE: '/dashboard/profile',
    SETTINGS: '/dashboard/settings',
    MY_ENQUIRIES: '/my-enquiries',
    MANAGE_LISTING: '/manage-listing',
  },

  PROFILE: '/profile',
  NOTIFICATIONS: '/notifications',

  ADMIN: {
    HOME: '/admin',
    USERS: '/admin/users',
    ANALYTICS: '/admin/analytics',
  },

  USER: {
    CONTACT_US: '/contact-us',
  },

  UNAUTHENTICATED: {
    HELP_VIDEOS: '/videos',
    FAQ: '/faqs',
    PRIVACY_POLICY: '/privacy',
    TERMS_AND_CONDITIONS: '/terms-of-service',
    GET_ESTIMATES: '/valuation',
    CREATE_LISTING: '/create-listing',
    CONTACT_US: '/contact-us',
    ARTICLES: '/articles',
    REPORTS: '/lp/reports',
  },

  AUTHENTICATED: {
    MY_PROFILE: '/my-profile',
  },
} as const;

export type Route = typeof ROUTES;

/**
 * API endpoint paths
 */
export const API_ENDPOINTS = {
  // Auth
  AUTH_LOGIN: '/v1/auth/login',
  AUTH_REGISTER: '/v1/auth/register',
  AUTH_LOGOUT: '/v1/auth/logout',
  AUTH_REFRESH: '/v1/auth/refresh-token',

  // Users
  USERS: '/v1/users',
  USER_BY_ID: (id: string) => `/v1/users/${id}`,
  USER_PROFILE: '/v1/users/profile',

  // General
  HEALTH: '/v1/health',
} as const;
